var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWeatherNotice = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11 4c1.64 0 3.075.878 3.861 2.19a3.499 3.499 0 0 1 4.621 2.978 3 3 0 0 1-.837 5.828l-2.523-4.36a1.722 1.722 0 0 0-2.915-.103l-.065.104L10.616 15H6.5a4 4 0 1 1 .254-7.992A4.5 4.5 0 0 1 11 4"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.2 11.249a.5.5 0 0 1 .865 0l4.632 8a.5.5 0 0 1-.433.751h-9.263l-.07-.005a.5.5 0 0 1-.363-.746zm.432 6.252a.48.48 0 0 0-.356.143l-.063.077a.5.5 0 0 0-.08.279.485.485 0 0 0 .398.491l.101.009q.16 0 .28-.08l.076-.064a.49.49 0 0 0 .144-.356.48.48 0 0 0-.144-.355l-.076-.064a.5.5 0 0 0-.178-.071zm0-3a.5.5 0 0 0-.5.5v1.5l.01.1a.5.5 0 0 0 .98 0l.01-.1v-1.5a.5.5 0 0 0-.5-.5",
  clipRule: "evenodd"
})));
export default SvgWeatherNotice;